import { sendBI } from 'backend/bi-sender';

export const moduleBiEvents = ({ on }) => {
	on('@init', () => {
		sendBI({
			message:`init`,
			id: '00'
		})
	})

	on('toggle/state', (_, stateBox) => {
		sendBI({
			message:`select content type -  ${stateBox}`,
			id: '01'
		})
	})

	on('startUpload/image', () => {
		sendBI({
			message:'upload image',
			id: '02'
		});
	})

	on('startUpload/pdf', () => {
		sendBI({
			message:'upload pdf',
			id: '03'
		});
	})

	on('open/lightbox', () => {
		sendBI({
			message:'open Download Lightbox',
			id: '04'
		});
	})

	on('change/image', (_, [key]) => {
		sendBI({
			message: `image changed: ${key}`,
			id: '05'
		});
	})

	on('click/startNow', () => {
		sendBI({
			message:'click Start Now LightBox',
			id: '10'
		});
	})

	on('click/createWebsite', () => {
		sendBI({
			message:'click Start Now LightBox',
			id: '11'
		});
	})
}